import {User} from 'hasta-la-vista-middleware-api/model'
import {AuthService} from 'hasta-la-vista-middleware-api/service'
import {Utils} from 'hasta-la-vista-ui-core'
/**
 * Created by richard on 2017/10/31.
 */
export default {
    name: 'profile-toolbar',

    props: {
        active: Boolean,
        guest: true,
        user: null
    },

    methods: {
        signOut() {
        	Promise.all([AuthService.signOut()]).then(([result]) => {

            },
            (error) => {
                Promise.reject(error)
            })
        },

        setUser(){
           //  AuthService.user().then((user)=>{
           //     this.user = user;
           //     this.guest = user.isGuest();
           // })
        },
    },
}



// WEBPACK FOOTER //
// ./src/components/profile/profile-toolbar/profile-toolbar.js